import { DiscModel } from './disc.model';

export class ProductDiscModel {
  public id: number = null;
  public position: string = null;
  public disc: DiscModel = new DiscModel();
  public checked = false;
  uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ProductDiscModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new ProductDiscModel().fromJSON(json));
      });
    }
    return refs;
  }
}
